import { FC } from 'react';

import { ImageTheme } from 'APP/components/ImageTheme/ImageTheme';

import styles from './BackgroundImage.styles.m.css';

export const BackgroundImage: FC = () => {
  return (
    <ImageTheme
      className={styles.background}
      lightImageName={PROJECT_CONFIG.imageAssets.mainBackgroundLight}
      darkImageName={PROJECT_CONFIG.imageAssets.mainBackgroundDark}
    />
  );
};
